<template>
  <div class="eb-submenu-wrap">
    <div :class="['eb-submenu', isActive ? 'active' : '']" @click="handleClick">
      <div class="eb-submenu__title">
        <span class="eb-submenu__icon"><slot name="icon" /></span>
        <slot name="title"></slot>
      </div>
      <span class="eb-submenu__arrow"><i :class="showSubMenu ? 'el-icon-caret-top' : 'el-icon-caret-bottom'" /></span>
    </div>
    <transition :name="menuTransitionName">
      <ul v-show="showSubMenu" class="eb-submenu__list">
        <slot name="default"></slot>
      </ul>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'EbSubmenu',
  props: {
    index: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      menuTransitionName: 'eb-zoom-in-top',
      showSubMenu: true,
    };
  },
  computed: {
    isActive() {
      return this.rootMenu.activeIndex.split('-')[0] === this.index;
    },
  },
  inject: ['rootMenu'],
  methods: {
    handleClick() {
      this.rootMenu.$emit('submenu-click', this);
      this.showSubMenu = !this.showSubMenu;
    },
  },
};
</script>


<style lang="less" scoped>
.eb-submenu-wrap {
  margin-bottom: 6px;

  &::after {
    content: "";
    display: block;
    height: 1px;
    margin: 6px 12px 0 20px;;
    overflow: hidden;
    background-color: #F6F6F6;
  }
}
.eb-submenu {
  padding: 0 12px 0 20px;
  position: relative;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;

  &:hover, &.active {
    color: var(--ui-main-color);
    background-color: var(--ui-bg-color);
  }

  .eb-submenu__title {
    position: relative;
    display: flex;
    align-items: center;
    font-size: 14px;
  }
  .eb-submenu__icon {
    font-size: 18px;
    margin-right: 8px;
  }
  .eb-submenu__arrow {
    font-size: 14px;
  }
}
.eb-submenu__list {
  display: flex;
  flex-flow: wrap;
  padding: 8px 12px 2px 20px;

  /deep/ li {
    background-color: transparent;
    box-sizing: border-box;
    width: 50%;
    height: auto;
    line-height: inherit;
    padding: 6px 0;

    &:hover {
      color: var(--ui-main-color);
    }
  }
}

.eb-zoom-in-top-enter-active,
.eb-zoom-in-top-leave-active {
  opacity: 1;
  transform: scaleY(1);
  transition: all 300ms cubic-bezier(0.23, 1, 0.32, 1);
  transform-origin: center top;
}
.eb-zoom-in-top-enter,
.eb-zoom-in-top-leave-active {
  opacity: 0;
  transform: scaleY(0);
}
</style>
